const AUTH_TOKEN = "authToken";
const DEAL_ID = "dealId";
const LOGIN_TYPE = "loginType";
const DEAL_AND_TOKEN = "dealAndToken";

export const getToken = () => {
  return localStorage.getItem(AUTH_TOKEN);
};

export const setToken = (token) => {
  if (token) {
    localStorage.setItem(AUTH_TOKEN, token);
  }
};

export const removeToken = () => {
  localStorage.removeItem(AUTH_TOKEN);
  localStorage.removeItem(LOGIN_TYPE);
  localStorage.removeItem(DEAL_AND_TOKEN);
};

export const setLoginType = (type) => {
  if (type) {
    localStorage.setItem(LOGIN_TYPE, type);
  }
};

export const getLoginType = () => {
  return localStorage.getItem(LOGIN_TYPE);
};

export const getDealId = () => {
  return localStorage.getItem(DEAL_ID);
};

export const setDealId = (dealId) => {
  if (dealId) {
    localStorage.setItem(DEAL_ID, dealId);
  }
};

export const removeDealId = () => {
  localStorage.removeItem(DEAL_ID);
};

export const getDealAndToken = () => {
  return localStorage.getItem(DEAL_AND_TOKEN);
};

export const setDealAndToken = (dealAndToken) => {
  if (dealAndToken) {
    localStorage.setItem(DEAL_AND_TOKEN, dealAndToken);
  }
};

export const formatString = (input) => {
  let stringWithoutHyphens = input.replace(/-/g, " ");

  return (
    stringWithoutHyphens.charAt(0).toUpperCase() + stringWithoutHyphens.slice(1)
  );
};

export const filterArrayByIssueType = (arr, issueTypeId) => {
  return arr.filter(
    (item) => item.attributes.issue_type.data.id === issueTypeId
  );
};

export const createImageElement = (
  source,
  altText,
  onClickCallback,
  height = "20px",
  width = "20px"
) => {
  const img = document.createElement("img");
  img.src = source;
  img.style.cssText = `height: ${height}; width: ${width}; cursor: pointer;`;
  img.alt = altText;
  img.onclick = onClickCallback;
  return img;
};

export const addThreeMonthsToDate = (inputDate) => {
  const date = new Date(inputDate);
  const day = date.getDate();
  date.setMonth(date.getMonth() + 3);
  if (date.getDate() < day) {
    date.setDate(0);
  }
  date.setDate(date.getDate() - 1);
  return date;
};

export const getCurrentDateForPrompt = () => {
  const date = new Date();

  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();

  // This arrangement can be altered based on how we want the date's format to appear.
  return `${day}-${month}-${year}`;
};

// Convert link to a tag in the text
const linkifyHtml = (html) => {
  if (!html) return "";
  const urlRegex = /(https?:\/\/[^\s<]+)/g;
  return html.replace(urlRegex, (url) => {
    return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
  });
};

// Replce \n with Breakline
export const commentBeautify = (comment) => {
  return linkifyHtml(comment.replace(/\n/g, "<br />"));
};

export const formatLetterTextToHTML = (text) => {
  return text
    // Convert Markdown-style bold (**text**) → <strong>text</strong>
    .replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>")
    // Replace \n with <br>
    .replace(/\n/g, "<br>")
    // Remove empty <p> (with or without <br>) unless it has class="grapple-lawyer-paragraph"
    .replace(/<p(?![^>]*\bgrapple-lawyer-paragraph\b)[^>]*>\s*(<br\s*\/?>)?\s*<\/p>/gi, "")
    // Remove blank <br> tags (standalone or consecutive extras)
    .replace(/(<br\s*\/?>\s*)+/gi, "<br>");
};


export const addMonthsReliable = (date, months) => {
  const d = new Date(date);
  const day = d.getDate();
  d.setMonth(d.getMonth() + months);
  if (d.getDate() < day) {
    d.setDate(0);
  }
  return d;
}

export const convertHtmlToPlainText = (html) => {
  // return html
  //   .replace(/<p>/gi, '')       // remove opening <p> tags
  //   .replace(/<\/p>/gi, '<br/>')   // replace closing </p> tags with newline
  //   .replace(/<br\s*\/?>/gi, '<br/>') // replace <br> or <br/> with newline
  //   .replace(/&nbsp;/g, ' ')    // decode common entities (optional)
  //   .replace(/&amp;/g, '&')     // handle &
  //   .trim();                    // remove leading/trailing whitespace
     return html.replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim();
}

export const employerLEtterBody = () => {
  return `<p>Dear Sir/Madam,</p>
          <p>Please find attached a letter concerning our client.</p>
          <p>We look forward to hearing from you. </p>
          <p>Kind regards,</p>`;
}

 export const addClassToEmptyPTags = (html)  => {
    if (!html) return html;
    return html.replace(
      /<p([^>]*)>\s*(<br\s*\/?>)?\s*<\/p>/gi,
      (match, attrs, br) => {
        // If already has the class, leave it
        if (/class\s*=\s*["'][^"']*\bgrapple-lawyer-paragraph\b/i.test(attrs)) {
          return match;
        }

        // Add the class
        if (attrs && attrs.trim().length > 0) {
          return `<p${attrs} class="grapple-lawyer-paragraph">${br || ""}</p>`;
        } else {
          return `<p class="grapple-lawyer-paragraph">${br || ""}</p>`;
        }
      }
    );
}

export const sendGridEmailTextMargin = (dynamicEmailText) => {
  return dynamicEmailText.replace(
        /<p(?![^>]*style=)([^>]*)>/gi,
        '<p$1 style="">'
      ).replace(
        /<p([^>]*?)style="(.*?)"(.*?)>/gi,
        (match, before, styles, after) => {
          return `<p${before}style="${styles}; margin-bottom:1em"${after}>`;
        }
      );
}